import React from "react";

import Modal from "../../../components/Modal";

import LoadingComponent from "./loadable";

export default props => (
    <Modal close={props.close} width="300px">
        <LoadingComponent {...props} />
    </Modal>
);
